export const questionFields = [
  { key: 'Inkomen', text: 'Inkomen', value: 'inkomen' },
  { key: 'Identiteit', text: 'Identiteit', value: 'identiteit' },
  { key: 'Leeftijd', text: 'Leeftijd', value: 'leeftijd' },
];